import { BLACK_900, getTestId } from '@airtel/air-design-system';
export var defaultProps = Object.assign({
  packTitle: {
    text: 'unlimited local & STD calls',
    type: 'body-single-line-sm-bold',
    color: BLACK_900
  },
  infoTagText: 'text label',
  strikedText: '1.5 GB',
  hideRightChevronIcon: false,
  iconName: 'MobileDataIcon',
  hideDivider: false,
  iconProps: {},
  packSubTitle: 'here is the text that will be used as the subtitle here is the text that will be used as the subtitlehere is the text that will be used as the subtitlehere is the text that will be used as the subtitle'
}, getTestId('PackDetailsListItemWidgetContainer'));